var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor run-javascript" },
    [
      _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("JavaScript Kodu"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "code-editor-wrapper" }, [
          _c("div", { staticClass: "code-editor-header" }, [
            _c("div", { staticClass: "tips" }, [
              _c(
                "div",
                { staticClass: "tip" },
                [
                  _c("md-icon", [_vm._v("info")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Bu blok, kullanıcının yazdığı JavaScript kodunu çalıştırır."
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tip" },
                [
                  _c("md-icon", [_vm._v("warning")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Güvenlik nedenlerinden dolayı bazı JavaScript özellikleri kısıtlanmıştır."
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "ai-assistant-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showPromptWizard },
                  },
                  [
                    _c("img", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        src: "/static/img/copilot.png",
                        width: "15",
                        height: "15",
                      },
                    }),
                    _vm._v(
                      "\n                            Supsis Asistan\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "JavaScript Asistanı", width: 800, footer: null },
          on: { cancel: _vm.handleAssistantClose },
          model: {
            value: _vm.showJsAssistant,
            callback: function ($$v) {
              _vm.showJsAssistant = $$v
            },
            expression: "showJsAssistant",
          },
        },
        [
          _c("div", { staticClass: "js-assistant-modal" }, [
            _c("div", { staticClass: "js-assistant-description" }, [
              _c("h4", [_vm._v("JavaScript kodunu yapay zeka ile oluşturun")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        Yapmak istediğiniz işlemi doğal dilde açıklayın, Supsis Asistan sizin için JavaScript kodunu\n                        oluştursun.\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "js-capabilities" }, [
                _c(
                  "div",
                  { staticClass: "capabilities-header" },
                  [
                    _c("a-icon", { attrs: { type: "bulb" } }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Yapabilecekleriniz:")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "capabilities-content" }, [
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("functions"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Hesaplamalar yapma")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("compare_arrows"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Veri dönüşümleri")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("filter_list"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Veri filtreleme")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("http"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("API istekleri yapma")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("today"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Tarih işlemleri")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_list_numbered"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Dizi işlemleri")]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "prompt-container" },
              [
                _c("s2-textarea", {
                  ref: "promptTextarea",
                  attrs: {
                    rows: 4,
                    placeholder:
                      "Örnek: Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle",
                  },
                  model: {
                    value: _vm.jsPrompt,
                    callback: function ($$v) {
                      _vm.jsPrompt = $$v
                    },
                    expression: "jsPrompt",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "example-prompts" }, [
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "calculator" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Harcama hesapla ve etiketle")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "Müşteri adını ve soyadını alarak tam ad oluştur ve selamlama mesajı hazırla"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "user" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Müşteri bilgisiyle mesaj hazırla")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          return _vm.selectExamplePrompt(
                            "API'den hava durumu bilgisi al ve sıcaklığa göre aktivite önerisi yap"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "cloud" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("API ile hava durumuna göre öneri")]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons-container" },
                  [
                    _c(
                      "a-button",
                      { on: { click: _vm.handleAssistantClose } },
                      [_vm._v("İptal")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.assistantLoading,
                        },
                        on: { click: _vm.generateJavaScriptCode },
                      },
                      [
                        _vm._v(
                          "\n                            Kod Oluştur\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "code-editor" }, [
      _c("div", { staticClass: "available-libraries" }, [
        _c("span", [_vm._v("Kullanılabilir Kütüphaneler:")]),
        _vm._v(" "),
        _c("code", [_vm._v("moment")]),
        _vm._v(", "),
        _c("code", [_vm._v("lodash (_)")]),
        _vm._v(", "),
        _c("code", [_vm._v("axios (sadece get ve post)")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "available-variables" }, [
        _c("span", [_vm._v("Kullanılabilir Değişkenler:")]),
        _vm._v(" "),
        _c("code", [_vm._v("params")]),
        _vm._v(" (önceki blokların değerleri),\n                        "),
        _c("code", [_vm._v("task.readAttribute(key, defaultValue)")]),
        _vm._v(",\n                        "),
        _c("code", [_vm._v("task.bindAttribute(data)")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "attribute-help" }, [
        _c("span", [_vm._v("Otomasyon Değişkenleri:")]),
        _vm._v(" "),
        _c("code", [_vm._v("block.blockId")]),
        _vm._v(", "),
        _c("code", [_vm._v("event.eventType.eventName")]),
        _vm._v(", "),
        _c("code", [_vm._v("system.date")]),
        _vm._v(",\n                        "),
        _c("code", [_vm._v("webhook.body.fieldName")]),
        _vm._v(" şeklinde kullanılabilir.\n                    "),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "monaco-editor-container",
        attrs: { id: "monaco-editor-container" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "code-restrictions" }, [
      _c("div", { staticClass: "restriction-title" }, [
        _vm._v("Kısıtlamalar:"),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "process.exit, child_process gibi tehlikeli Node.js özellikleri yasaktır"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("require(), eval() ve Function() fonksiyonları kullanılamaz"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Dosya sistemi (fs), kripto ve ağ işlemleri kısıtlanmıştır"),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Kod çalışma süresi 5 saniye ile sınırlıdır")]),
        _vm._v(" "),
        _c("li", [_vm._v("HTTP istekleri için zaman aşımı 3 saniyedir")]),
        _vm._v(" "),
        _c("li", [_vm._v("Sonsuz döngüler ve serverlar oluşturulamaz")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "example-usage" }, [
      _c("div", { staticClass: "example-title" }, [_vm._v("Kod Örneği:")]),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "async function main(params) {\n  // Moment kütüphanesini kullanma örneği\n  const now = moment().format('YYYY-MM-DD HH:mm:ss');\n\n  // Lodash kullanımı\n  const users = [\n    { name: 'Mesut', age: 30 },\n    { name: 'Ahmet', age: 25 }\n  ];\n  const oldest = _.maxBy(users, 'age');\n\n  // Otomasyon değişkenlerini kullanma\n  const date = task.readAttribute('system.date');\n  const contactName = task.readAttribute('contact.fullname');\n\n  // Supsis SDK kullanım örneği\n  let result = {};\n\n  try {\n    // Kullanıcıları listeleme\n    const userList = await supsis.users.list();\n    result.userCount = userList.length;\n\n    // Kişi bilgisi alma (varsa)\n    if (params.contactId) {\n      const contact = await supsis.contact.get(params.contactId);\n      result.contactInfo = {\n        name: contact.fullname,\n        email: contact.email\n      };\n    }\n\n    // Modüller üzerinde çalışma\n    // 1. Tüm modülleri listele\n    const modules = await supsis.module.list();\n    result.moduleCount = modules.length;\n\n    // 2. Özel bir modül ile çalışma (örnek: müşteriler modülü)\n    // const newCustomer = await supsis.module.customers.create({\n    //   fullname: contactName,\n    //   registerDate: now,\n    //   status: 'active'\n    // });\n    // result.newCustomerId = newCustomer._id;\n\n    // 3. Modül kaydı arama\n    // const customerRecords = await supsis.module.customers.search({\n    //   filters: [{ field: 'status', operator: 'eq', value: 'active' }],\n    //   sort: { fullname: 1 },\n    //   cursor: { page: 1, perPage: 10 }\n    // });\n    // result.customerCount = customerRecords.total;\n  } catch (error) {\n    // Hata yönetimi\n    result.error = error.message;\n  }\n\n  // Döndürülen değer, bloğun çıktısı olarak kaydedilir\n  return {\n    currentTime: now,\n    oldestUser: oldest.name,\n    calculated: params.previousValue ? params.previousValue * 2 : 0,\n    systemDate: date,\n    contactName: contactName,\n    apiResults: result\n  };\n}\n"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }